import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {State} from './state';
import {map} from 'rxjs';
import {Team, TeamWorker} from '../model/familyAndTeam';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {


    constructor(private http: HttpClient) {
    }



    getTeamsForProvider() {
      console.log('entering get getTeamsForProvider');
      const providerId : number = environment.providerId;
      const headers =  State.getAuthHeaders();
      const params = new HttpParams()
            .append('providerId', providerId)
            .append('excludeFamilies', 'yes')
          .append('includeMembers', 'yes');

      return this.http.get(State.config.host+ '/api/practitioner-groups', { headers: headers, params: params })
        .pipe(map((response: any) => response,
          (error: any) => {
            throw error;
          }));
    }

    getTeamMembersByTeamId(teamId: number) {
      const headers =  State.getAuthHeaders();
      let params = new HttpParams().append('teamId', ''+teamId);
        return this.http.get(State.config.host+ '/api/team-members', {params: params, headers: headers}).pipe(map((r: any) => {
          return r;
        }, (error: any) => {
          throw error;
        }));
    }


  getProvider() {
    const headers =  State.getAuthHeaders();
    return this.http.get(State.config.host+ '/api/providers/' + +environment.providerId, {  headers: headers}).pipe(map((r: any) => {
      return r;
    }, (error: any) => {
      throw error;
    }));
  }

  saveTeam(g: Team) {
    const headers =  State.getAuthHeaders();
    return this.http.post(State.config.host+ '/api/practitioner-group', g, {
      headers: headers.append('allowDupes', 'true')
    }).pipe(map((response: any): Team => response, (error: any) => {
      throw error;
    }));

  }

  saveTeamMembers(teamMembers :TeamWorker[] ) {
    const headers =  State.getAuthHeaders().append('allowDupes', 'true');
    return this.http.post(State.config.host+ '/api/team-members', teamMembers, {headers: headers})
      .pipe(map((response: any): TeamWorker[] => response, (error: any) => {
      throw error;
    }));

}

}
